import React from 'react';


import NewFilterPinned from '../NewFilter/NewFilter';

import {
  Container,
} from './styles';
import { StyledDrawer } from './styles';

type PropsFilter = {
  onClose: () => void;
  visible: boolean;
};

export default function NewDrawerFilter(props: PropsFilter) {
  const { onClose, visible } = props;

  return (
    <Container className="new-filter-container">
      <StyledDrawer
        title="Filtros"
        placement="left"
        className="drawer-filter"
        headerStyle={{ backgroundColor: '#F0F0F0', color: '#000000' }}
        onClose={onClose}
        visible={visible}
      >
        <NewFilterPinned />
      </StyledDrawer>
    </Container>
  );
}
